import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1db5ef5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-square-dotted" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';
import { Guid } from '@/lib';
import { TodoItemType } from '@/logic/workspaces/tickets/todos/_def.todos';
import { clipboardTicketTitle } from '@/controllers/workspaces/tickets/_spec/ticket.controller'
import sys from '@/sys';



export default /*#__PURE__*/_defineComponent({
  __name: 'TodoTitleComponent',
  props: {
    model: {},
    active: { type: Boolean }
  },
  emits: ['number', 'name', 'file', 'link', 'task'],
  setup(__props: any, { emit: __emit }) {

const props = __props

//const emits = defineEmits(['recreate'])

const emit = __emit

const h = { //'h' for 'handlers'

    number() {

        if (props.model.ticket != null) clipboardTicketTitle(props.model.ticket)

        else sys.warn('/workspaces/ticket is null')
    },

    name() {

    },

    taskCreate(t: TicketRmodel) {

        emit('task', t)
    }

}


return (_ctx: any,_cache: any) => {
  return (_ctx.model.ticket != null)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("span", {
          class: "clickable title-n",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (h.number && h.number(...args)))
        }, [
          _createTextVNode("#" + _toDisplayString(_ctx.model.ticket.n), 1),
          (_ctx.model.todo_type != null && _ctx.model.todo_type != 'T')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("'")
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", {
          class: "clickable",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (h.name && h.name(...args)))
        }, _toDisplayString(_ctx.model.ticket.name), 1),
        (_ctx.model.todo_type == 'T')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.active)
                ? (_openBlock(), _createElementBlock("strong", _hoisted_2, "R"))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "clickable",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (h.taskCreate(_ctx.model.ticket)))
                  }, _hoisted_4))
            ], 64))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "clickable",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (h.taskCreate(_ctx.model.ticket)))
            }, _hoisted_6))
      ]))
    : _createCommentVNode("", true)
}
}

})